
export const NORMAL = 0
export const SHOOT_THE_MAIN_SHELF_BY_GROUP = 1
export const SHOOT_THE_SECONDARY_DISPLAY_BY_GROUP = 2

export const NORMAL_CN = '无'
export const SHOOT_THE_MAIN_SHELF_BY_GROUP_CN = '主货架分组拍摄'
export const SHOOT_THE_SECONDARY_DISPLAY_BY_GROUP_CN = '二级陈列分组拍摄'

export const options = [
  {
    value: NORMAL,
    label: NORMAL_CN,
  },
  {
    value: SHOOT_THE_MAIN_SHELF_BY_GROUP,
    label: SHOOT_THE_MAIN_SHELF_BY_GROUP_CN,
  },
  {
    value: SHOOT_THE_SECONDARY_DISPLAY_BY_GROUP,
    label: SHOOT_THE_SECONDARY_DISPLAY_BY_GROUP_CN,
  },
]

export const labelsByValue = _.mapValues(_.keyBy(options, 'value'), 'label')



// WEBPACK FOOTER //
// ./src/views/question-editor/format/take-photo-scenes.js